import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import {
  ImageFromDataState,
  toImageData,
} from '../../../cross-team-shared/state/image-from-data-state';
import { displayImageWithCanvas } from '../../../shared/misc-utilities/image-utils';
import { ImageContentStore } from '../state/image-content-store';

@Component({
  selector: 'h3-image-overlay-data',
  templateUrl: './image-overlay-data.component.html',
  styleUrls: ['./image-overlay-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageOverlayDataComponent
  extends DirectiveSuperclass
  implements OnInit
{
  imageOverlayData$!: Observable<Uint8ClampedArray | undefined>;
  store = inject(ImageContentStore);

  private canvas!: HTMLCanvasElement;

  @ViewChild('canvas')
  set canvasRef(ref: ElementRef) {
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    if (ref) {
      this.canvas = ref.nativeElement;
      this.paint(this.store.state().imageOverlayData);
    }
  }

  ngOnInit() {
    this.imageOverlayData$ = this.store('imageOverlayData').$;
    this.subscribeTo(this.imageOverlayData$, (imageOverlayData) =>
      this.paint(imageOverlayData),
    );
  }

  private paint(imageOverlayData?: Uint8ClampedArray) {
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    if (this.canvas && imageOverlayData) {
      const { width, height } = this.store.state().sensorRendererState;
      const imageData = toImageData(
        new ImageFromDataState(width, height, imageOverlayData),
      );
      displayImageWithCanvas(imageData, this.canvas);
    }
  }
}
